import React from 'react';
import PageHeader from '../components/PageHeader';

const CMS = () => {
  const pages = [
    { id: 1, title: 'Home Page', slug: 'home', status: 'published', updatedAt: '2024-01-20' },
    { id: 2, title: 'About Us', slug: 'about', status: 'published', updatedAt: '2024-01-15' },
    { id: 3, title: 'Contact Us', slug: 'contact', status: 'draft', updatedAt: '2024-01-10' },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="CMS Management"
        description="Manage website pages and content"
        breadcrumbs={['Home', 'CMS']}
      />

      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-100">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700">Page Title</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700">Slug</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700">Status</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700">Updated</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700">Actions</th>
            </tr>
          </thead>
          <tbody>
            {pages.map(page => (
              <tr key={page.id} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="px-6 py-4 text-sm font-medium text-gray-900">{page.title}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{page.slug}</td>
                <td className="px-6 py-4 text-sm">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    page.status === 'published'
                      ? 'bg-green-100 text-green-700'
                      : 'bg-yellow-100 text-yellow-700'
                  }`}>
                    {page.status.charAt(0).toUpperCase() + page.status.slice(1)}
                  </span>
                </td>
                <td className="px-6 py-4 text-sm text-gray-600">{page.updatedAt}</td>
                <td className="px-6 py-4 text-sm">
                  <button className="text-amber-600 hover:text-amber-700 font-medium">Edit</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CMS;
